<div class="relative w-full h-full container">
  <ng-container *ngIf="status === 0">
    <div class="flex flex-column gap-3">
      <div class="flex justify-content-center">
        <div class="function-icon" (click)="showCamera()">
          <i class="pi pi-camera"></i>
        </div>
      </div>
      <div class="flex justify-content-center">
        <div class="function-icon" (click)="showFileUploader()">
          <i class="pi pi-upload"></i>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="status === 1">
    processing...
  </ng-container>
  <ng-container *ngIf="status === 2">
    <img class="max-w-full max-h-full" [src]="tongueCamera.croppedDisplayDataUrl">
    <i class="pi pi-times delete-icon" (click)="reset()"></i>
  </ng-container>
</div>
<app-tongue-camera (onUpload)="uploadPhoto($event)"></app-tongue-camera>
